"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Search = require("./Search.style");
var _SearchBox = _interopRequireDefault(require("../../../../../../SearchBox"));
var _SubMenu = require("../../../../SubMenu/SubMenu.style");
//

const SearchFunctionality = _ref => {
  let {
    selected,
    setInputRef,
    id,
    onClick,
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement(_SubMenu.SubMenuList, {
    "data-test-id": "subMenu-".concat(id)
  }, /*#__PURE__*/React.createElement(_SubMenu.SubMenuItem, {
    showing: selected,
    noSeparator: true,
    noHover: true,
    positionToLeft: true
  }, /*#__PURE__*/React.createElement(_SubMenu.SubMenuItemInner, {
    showing: selected,
    listLength: 2,
    index: 0
  }, /*#__PURE__*/React.createElement(_Search.SearchBoxWrapper, null, /*#__PURE__*/React.createElement(_SearchBox.default, {
    id: id,
    setInputRef: setInputRef,
    onSearched: onClick,
    clearOnSearch: true,
    onClose: onClose
  })))));
};
var _default = exports.default = SearchFunctionality;